export default "/_next/static/chunks/Photosphere1.jpg.985718b369e4139c3f8806e4bf1d890d.chunk";